import { Serializable } from 'starbase-launcher';
import { Battle } from './battle';
import { ImageFile } from './imageFile';

export class BattleLink implements Serializable<BattleLink> {
  public uid: number;
  public imageUID: number;
  public image: ImageFile;
  /** Required link to the battle record */
  public battleUID: number;
  public battle: Battle;

  public deserialize(input) {
    return Object.assign(new BattleLink(), input);
  }
}
